import { MenuGroup } from '../types/menu';
import { AzureDevOpsIcon, AnnouncementIcon } from '../components/icons';

export const menuConfiguration: MenuGroup[] = [
  {
    id: 'main-menu',
    label: 'Main Menu',
    icon: {
      type: 'material',
      name: 'Menu'
    },
    items: [
      {
        id: 'home',
        text: 'Home',
        path: '/',
        icon: {
          type: 'material',
          name: 'Home'
        }
      },
      {
        id: 'marketplace',
        text: 'Marketplace',
        path: '/marketplace',
        icon: {
          type: 'material',
          name: 'Store'
        },
        subItems: [
          {
            id: 'azure-devops',
            text: 'Azure DevOps',
            path: '/template?filters%5Bkind%5D=template&filters%5Btags%5D=azure-devops&filters%5Buser%5D=all',
            icon: {
              type: 'component',
              component: AzureDevOpsIcon
            }
          },
          // {
          //   id: 'infrastructure',
          //   text: 'Infraestructura',
          //   path: '/template?filters%5Bkind%5D=template&filters%5Btags%5D=infra&filters%5Buser%5D=all',
          //   icon: {
          //     type: 'material',
          //     name: 'Cloud'
          //   }
          // }
        ]
      },
      // {
      //   id: 'documentation',
      //   text: 'Documentación',
      //   path: '/docs',
      //   icon: {
      //     type: 'material',
      //     name: 'LibraryBooks'
      //   }
      // }
    ]
  },
  {
    id: 'explore-menu',
    label: 'Explore',
    items: [
      {
        id: 'catalog',
        text: 'Catalog',
        path: '/catalog?filters%5Bkind%5D=template&filters%5Buser%5D=all',
        icon: {
          type: 'material',
          name: 'Storage'
        }
      },
      // {
      //   id: 'apis',
      //   text: 'APIs',
      //   path: '/api-docs',
      //   icon: {
      //     type: 'material',
      //     name: 'Code'
      //   }
      // },
      {
        id: 'template-tasks',
        text: 'Template Tasks',
        path: '/create/tasks',
        icon: {
          type: 'material',
          name: 'Description'
        }
      }
    ]
  },
  // {
  //   id: 'communication-menu',
  //   label: 'Comunicaciones',
  //   items: [
  //     {
  //       id: 'announcements',
  //       text: 'Anuncios',
  //       path: '/announcements',
  //       icon: {
  //         type: 'component',
  //         component: AnnouncementIcon
  //       }
  //     },
  //     {
  //       id: 'notifications',
  //       text: 'Notificaciones',
  //       path: '/notifications',
  //       icon: {
  //         type: 'material',
  //         name: 'Notifications'
  //       }
  //     }
  //   ]
  // },
  {
    id: 'links-menu',
    label: 'Links',
    adminOnly: false,
    items: [
      {
        id: 'links',
        text: 'Quick Links',
        path: '/links',
        icon: {
          type: 'material',
          name: 'Link'
        }
      }
    ]
  },
  {
    id: 'admin-menu',
    label: 'Administration',
    adminOnly: true,
    items: [
      {
        id: 'administration',
        text: 'Administration',
        path: '/admin',
        icon: {
          type: 'material',
          name: 'Settings'
        },
        subItems: [
          {
            id: 'create-template',
            text: 'Create Template',
            path: '/create',
            icon: {
              type: 'material',
              name: 'AddCircleOutline'
            }
          },
          {
            id: 'create-announcement',
            text: 'Create Announcement',
            path: '/announcements/admin',
            icon: {
              type: 'material',
              name: 'Notifications'
            }
          }
        ]
      }
    ]
  }
];
